import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// 开发环境下引入mock数据（暂时禁用，连接真实后端服务）
// if (process.env.NODE_ENV === 'development') {
//   require('./mock');
// }
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './assets/css/global.css';
import axios from 'axios';

// 配置axios基础路径（使用相对路径，通过devServer代理转发）
axios.defaults.baseURL = '/api';
// 配置响应拦截器
axios.interceptors.response.use(response => {
  return response.data;
}, error => {
  console.error('请求错误:', error);
  return Promise.reject(error);
});

// 将axios添加到Vue原型链
Vue.prototype.$axios = axios;

// 使用ElementUI
Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
